<template>
    <div class="row hm-calendar-container">
        <div class="col-12">
            <div class="card border-0">
                <div class="card-body p-0">
                    <div class="d-flex justify-content-between p-3">
                        <h3 class="p-0 m-0">
                            <template v-if="dayOptions.includes(filters.optionValue)">{{ currentPeriodStart.format('DD MMM YYYY') }}</template>
                            <template v-else-if="weekOptions.includes(filters.optionValue)">{{ currentPeriodStart.format('DD MMM YYYY') }} - {{ currentPeriodEnd.format('DD MMM YYYY') }}</template>
                            <template v-else-if="monthOptions.includes(filters.optionValue)">{{ currentPeriodStart.format('MMM YYYY') }}</template>
                            <i @click="getPreviousData" class="bi bi-chevron-left cursor-pointer fs-5"></i>
                            <i @click="getNextData" class="bi bi-chevron-right cursor-pointer fs-5"></i>
                        </h3>
                        <div class="d-flex gap-2">
                            <div class="row justify-content-end">
                                <div class="col-auto pe-0">
                                    <button
                                        type="button"
                                        class="btn btn-sm btn-outline-danger"
                                        @click="resetFilter"
                                    >Reset</button>
                                </div>
                                <div class="col-auto pe-0 hm-db--date-filter" style="width: 150px;">
                                    <Select2
                                        v-model="filters.optionValue"
                                        :options="filterOptions"
                                        :settings="{ minimumResultsForSearch: 'Infinity', placeholder: 'Filter Order', width: '100%' }"
                                        class=""
                                    />
                                </div>
                                <div class="col-auto pe-0">
                                    <button
                                        type="button"
                                        class="btn btn-sm"
                                        :class="[filters.optionValue === 'today' ? 'btn-theme' : 'btn-outline-theme']"
                                        @click="filters.optionValue='today'"
                                    >Today</button>
                                </div>
                                <div class="col-auto pe-0">
                                    <button
                                        type="button"
                                        class="btn btn-sm"
                                        :class="[filters.optionValue === 'yesterday' ? 'btn-theme' : 'btn-outline-theme']"
                                        @click="filters.optionValue='yesterday'"
                                    >Yesterday</button>
                                </div>
                                <div class="col-auto">
                                    <input
                                        type="text"
                                        class="form-control form-control-sm"
                                        placeholder="Search Order"
                                        v-model="filters.search"
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body p-0 border-0">
                    <div class="hm-due-date-table">
                        <!-- Display monthly data -->
                        <table class="table table-bordered mb-0 hm-table-fixed">
                            <thead class="due-date-table-head">
                                <tr>
                                    <td
                                        class="text-center"
                                        v-for="(week, index) in weekDays"
                                        :key="index"
                                    >
                                        {{ week.day }}
                                        <div v-if="weekOptions.includes(filters.optionValue)" class="fs-6">
                                            {{ week.date }}/{{ week.year }}
                                        </div>
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="weekOptions.includes(filters.optionValue)">
                                    <td v-for="(week, index) in weekDays" :key="index">
                                        <div class="hm-day-container">
                                            <div class="mx-auto">
                                                <!-- Display order history data -->
                                                <template
                                                    v-if="filteredHistoryData[week.formattedDate]"
                                                    v-for="(element,historyDate) in filteredHistoryData[week.formattedDate]"
                                                    class="order-list-group"
                                                >
                                                    <div
                                                        class="hm-service-card p-2 mb-1 rounded order-list-group-item position-relative"
                                                        :class="getRandomClass()"
                                                        @contextmenu.prevent.stop="orderItemClick($event, element)"
                                                    >
                                                        <span
                                                            class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-theme cursor-pointer"
                                                            data-bs-toggle="popover"
                                                            data-bs-trigger="hover focus click"
                                                            data-bs-placement="top"
                                                            data-bs-title="Work History"
                                                            :data-bs-content="preparePopoverContent(element)"
                                                            data-bs-html="true"
                                                        >{{element?.histories?.length}}</span>
                                                        <div class="pt-2 hm-fs-11">
                                                            <div class="text-black text-truncate d-inline-block" style="width: 120px">{{ element?.order?.customer?.name || '' }}</div>
                                                            <div class="text-truncate d-inline-block" style="width: 120px">{{ element?.order?.address?.address + ' ' + element?.order?.address?.address_1 + ' ' + element?.order?.address?.city }}</div>
                                                            <div>{{ element?.order?.address?.postal_code || '' }}</div>
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr v-else v-for="(week, index) in calendar" :key="index">
                                    <td
                                        v-for="item in week"
                                        :key="item.day"
                                        class=""
                                        :class="{ 'text-muted': item.day === '' }"
                                    >
                                        <div class="hm-day-container">
                                            <div class="">{{ item.day }}</div>
                                            <!-- Iterate the due date services and display the service name -->
                                            <div class="mx-auto">
                                                <template
                                                    v-if="filteredHistoryData[item.date]"
                                                    v-for="(element,historyDate) in filteredHistoryData[item.date]"
                                                    class="order-list-group"
                                                >
                                                    <div
                                                        class="hm-service-card p-2 mb-1 rounded order-list-group-item position-relative"
                                                        :class="getRandomClass()"
                                                        @contextmenu.prevent.stop="orderItemClick($event, element)"
                                                    >
                                                        <span
                                                            class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-theme cursor-pointer"
                                                            data-bs-toggle="popover"
                                                            data-bs-trigger="hover focus click"
                                                            data-bs-placement="top"
                                                            data-bs-title="Work History"
                                                            :data-bs-content="preparePopoverContent(element)"
                                                            data-bs-html="true"
                                                        >{{element?.histories?.length}}</span>
                                                        <div class="pt-2 hm-fs-11">
                                                            <div class="text-black text-truncate d-inline-block" style="width: 120px">{{ element?.order?.customer?.name || '' }}</div>
                                                            <div class="text-truncate d-inline-block" style="width: 120px">{{ element?.order?.address?.address + ' ' + element?.order?.address?.address_1 + ' ' + element?.order?.address?.city }}</div>
                                                            <div>{{ element?.order?.address?.postal_code || '' }}</div>
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <vue-simple-context-menu
        element-id="rightClickMenu"
        :options="rightClickMenu"
        ref="rightClickMenu"
        @option-clicked="handleRightMenuClick"
    >
    </vue-simple-context-menu>
</template>
<script>
import { nextTick } from 'vue';
import moment from "moment";
import Select2 from "vue3-select2-component";
import VueSimpleContextMenu from "vue-simple-context-menu";
import "vue-simple-context-menu/dist/vue-simple-context-menu.css";
import axios from "axios";
import * as bootstrap from 'bootstrap';

export default {
    components: {
        Select2,
        VueSimpleContextMenu
    },
    data() {
        return {
            isLoading: false,
            selectedDate: moment(),
            calendar: [],
            startOfWeek: "",
            endOfWeek: "",
            currentWeek: "",
            currentMonth: "",
            weekDays: [],
            monthDates: [],
            orders: [],
            screenHeight: "",
            rightClickMenu: [
                {name: 'View Order', job: 'view-order'},
            ],
            filters: {
                search: "",
                optionValue: 'this_month',
            },
            filterOptions: [
                {id: 'last_week', text: 'Last Week'},
                {id: 'this_week', text: 'This Week'},
                {id: 'last_month', text: 'Last Month'},
                {id: 'this_month', text: 'This Month'},
                //{id: 'last_three_month', text: 'Last 3 Months'},
                //{id: 'this_year', text: 'This Year'},
                //{id: 'last_year', text: 'Last Year'}
            ],
            displayDate: moment().format('MMM YYYY'),
            currentPeriodStart: "",
            currentPeriodEnd: "",
            dayOptions: ['today', 'yesterday', 'custom_day'],
            weekOptions: ['last_week','this_week', 'next_week', 'custom_week'],
            monthOptions: ['last_month','this_month', 'next_month' , 'custom_month'],
            yearOptions: ['this_year', 'next_year', 'custom_year'],
            orderHistory: []
        };
    },
    created() {
        moment.utc();
        // Prepare current week
        this.startOfWeek = moment().startOf("isoWeek");
        this.endOfWeek = moment().endOf("isoWeek");
        this.currentWeek = this.startOfWeek + " - " + this.endOfWeek;

        // Prepare current month
        this.currentMonth = moment();
        this.currentPeriodStart = moment().startOf("month");
        this.currentPeriodEnd = moment().endOf("month");

        //this.initializeCalendar();
    },
    computed: {
        filteredOrders() {
            const term = this.filters.search.toLowerCase();
            return this.orders.filter((order) => {
                // Prepare an array of searchable fields
                const fieldsToSearch = [
                order.booking_address,
                order.name,
                order.full_name,
                order.account_type,
                order.email,
                order.phone_number,
                order.full_address,
                order.contact_person_phone_number,
                order.contact_person_full_name,
                ];

                // Add all service names from order_items
                if (order.order_items && Array.isArray(order.order_items)) {
                    order.order_items.forEach((item) =>
                        fieldsToSearch.push(item.service_name)
                    );
                }

                // Add all handyman names from order_handymans
                if (order.order_handymans && Array.isArray(order.order_handymans)) {
                    order.order_handymans.forEach((handyman) =>
                        fieldsToSearch.push(handyman.handyman?.name)
                    );
                }

                // Check if any field contains the search term
                return fieldsToSearch.some(
                (field) =>
                    field && field.toLowerCase().includes(term)
                );
            });
        },
        filteredHistoryData() {
            const term = this.filters.search.toLowerCase();

            // Create a new object to store the filtered results
            const filteredResults = {};

            // Iterate over the dates
            for (const date in this.orderHistory) {
                // Create a new object for the current date
                filteredResults[date] = {};

                // Iterate over the orders for the current date
                for (const orderId in this.orderHistory[date]) {
                    const order = this.orderHistory[date][orderId].order;

                    // Prepare an array of searchable fields
                    const fieldsToSearch = [
                        order.booking_address,
                        order.order_number,
                    ];

                    // Add all address fields for the search
                    if (order.address && order.address.length > 0) {
                        fieldsToSearch.push(order.address.address);
                        fieldsToSearch.push(order.address.address_1);
                        fieldsToSearch.push(order.address.address_2);
                        fieldsToSearch.push(order.address.city);
                        fieldsToSearch.push(order.address.state);
                        fieldsToSearch.push(order.address.country);
                        fieldsToSearch.push(order.address.postal_code);
                        fieldsToSearch.push(order.address.full_address);
                    }

                    // Add customer detail fields
                    fieldsToSearch.push(order.customer?.name);
                    fieldsToSearch.push(order.customer?.email);
                    fieldsToSearch.push(order.customer?.phone_number);

                    // Check if any field contains the search term
                    const isMatch = fieldsToSearch.some(
                        (field) =>
                            field && field.toLowerCase().includes(term)
                    );

                    // If there's a match, add the order to the filtered results
                    if (isMatch) {
                        filteredResults[date][orderId] = this.orderHistory[date][orderId];
                    }
                }

                // If no orders match for the current date, remove the date from the results
                if (Object.keys(filteredResults[date]).length === 0) {
                    delete filteredResults[date];
                }
            }

            return filteredResults;
        },
    },
    mounted() {
        this.screenHeight = window.innerHeight - 150;

        window.addEventListener("resize", () => {
            this.screenHeight = window.innerHeight - 150;
        });

        this.preparedWeekDays();
        this.generateCalendar();
        this.initializePopovers();
    },
    methods: {
        formatDate(date, format) {
            return moment(date).format(format);
        },
        initializeCalendar() {
            // Set the locale to ensure the week starts on Monday
            moment.locale('en', {
                week: {
                    dow: 1, // Monday is the first day of the week.
                },
            });

            // Generate week day labels
            // Generate week day labels
            this.weekDays = moment.weekdaysShort()?.map(day => {
                return { day: day };
            });
            this.weekDays.push(this.weekDays.shift()); // Adjust to start from Monday

            // Generate dates for the current month
            let start = this.currentPeriodStart.clone();
            let end = start.clone();

            if (this.currentPeriodStart.isSame(moment().startOf('month'), 'month')) {
                end = start.clone().endOf('month');
            } else if (this.currentPeriodStart.isSame(moment().subtract(1, 'month').startOf('month'), 'month')) {
                end = start.clone().endOf('month');
            } else {
                end = start.clone().endOf('month');
            }

            let startOfMonth = start.clone().startOf('week');
            let endOfMonth = end.clone().endOf('week');

            //console.log(startOfMonth);
            //console.log(endOfMonth);


            this.monthDates = [];
            let weeks = [];
            let currentWeek = [];
            let currentDay = startOfMonth.clone();

            while (currentDay.isBefore(endOfMonth)) {
                if (currentWeek.length === 7) { // Complete a week
                    weeks.push(currentWeek);
                    currentWeek = []; // Start a new week
                }

                if (currentDay.month() === moment().month()) {
                    currentWeek.push({
                        year: currentDay.format("YY"),
                        date: currentDay.format("DD"),
                        day: currentDay.format("ddd"),
                        formattedDate: currentDay.format("YYYY-MM-DD"),
                    });
                } else {
                    currentWeek.push(null); // Push null for days outside the month to keep the structure
                }

                currentDay.add(1, 'days');
            }
            if (currentWeek.length > 0) { // Push the last week if it has any days
                weeks.push(currentWeek);
            }

            this.monthDates = weeks; // Set the weeks array to monthDates
        },
        getOrders() {
            let self = this;
            let postData = {
                search_term: this.filters.search,
                search_type: this.filters.optionValue,
                start_date: this.currentPeriodStart.format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                end_date: this.currentPeriodEnd.format('YYYY-MM-DDTHH:mm:ss.SSSZ')
            };
            /* axios
                .post("/admin/orders/order-histories-dashboard", postData)
                .then((response) => {
                    self.orders = response.data.orders;
                })
                .catch((error) => {
                    console.log(error);
                }); */

            // Get order history
            axios.post("/api/admin/order-history", postData)
                .then((response) => {
                    self.orderHistory = response.data.orders;
                    self.initializePopovers();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        generateCalendar() {
            const currentDate = this.currentMonth;
            const year = currentDate.year();
            const month = currentDate.month();
            const firstDayOfMonth = moment([year, month, 1]).day(); // Day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
            const daysInMonth = currentDate.daysInMonth();

            const prevMonthDays = (firstDayOfMonth === 0 ? 6 : firstDayOfMonth - 1); // Adjusting for Monday as the first day of the week
            //const prevMonthDays = firstDayOfMonth === 0 ? 6 : firstDayOfMonth;
            const totalDays = prevMonthDays + daysInMonth;

            const calendar = [];
            let dayCounter = 1;

            for (let i = 0; i < 6; i++) {
                const week = [];
                for (let j = 0; j < 7; j++) {
                    if (i === 0 && j < prevMonthDays) {
                        week.push({ day: "", date: "" });
                    } else if (dayCounter <= daysInMonth) {
                        week.push({
                            day: dayCounter,
                            date: moment([year, month, dayCounter]).format('YYYY-MM-DD')
                        });
                        dayCounter++;
                    } else {
                        week.push({ day: "", date: "" });
                    }
                }

                // Check if the week contains any non-empty day
                if (week.some((item) => item.day !== "")) {
                    calendar.push(week);
                }
            }

            this.calendar = calendar;

            // Generate week day labels
            this.preparedWeekDays();

            this.getOrders();
        },
        preparedWeekDays() {
            const startDate = this.startOfWeek; // Start of the current week
            const endDate = this.endOfWeek; // End of the current week

            const currentDay = moment(startDate);
            const weekDays = [];
            while (currentDay.isSameOrBefore(endDate)) {
                weekDays.push({
                    year: currentDay.format("YY"),
                    date: currentDay.format("DD"),
                    day: currentDay.format("ddd"),
                    formattedDate: currentDay.format("YYYY-MM-DD"),
                });
                currentDay.add(1, "day");
            }

            this.weekDays = weekDays;
        },
        generateWeekCalendar() {
            this.preparedWeekDays();
            // Get the data from the database
            this.getOrders();
        },
        getRandomClass() {
            let cardItemClasses = [
                "task-bg-green",
                "task-bg-light-green",
                "task-bg-purple",
                "task-bg-orange",
                "task-bg-warning",
                "task-bg-blue",
                "task-bg-default",
                "task-bg-pink",
            ];
            return cardItemClasses[
                Math.floor(Math.random() * cardItemClasses.length)
            ];
        },
        orderItemClick(event, item) {
            this.$refs.rightClickMenu.showMenu(event, item);
        },
        handleRightMenuClick(event) {
            if (event.option.job === "view-order") {
                window.open(
                    "/admin/orders/" + event.item.order.order_number,
                    "_blank"
                );
            }
        },
        resetFilter() {
            this.filters.search = "";
            this.filters.optionValue = "this_month";
            this.generateCalendar();
        },
        prepareDisplayDate() {
            let filterType = this.filters.optionValue;
            if (filterType === "today") {
                this.displayDate = "Today";
                // Prepare start of the day and end of the day
                this.currentPeriodStart = moment().startOf("day");
                this.currentPeriodEnd = moment().endOf("day");
            }
            else if (filterType === "yesterday") {
                this.displayDate = "Yesterday";

                this.currentPeriodStart = moment().subtract(1, "days").startOf("day");
                this.currentPeriodEnd = moment().subtract(1, "days").endOf("day");
            }
            else if (filterType === "this_week") {
                this.displayDate = moment().startOf("isoWeek").format('DD MMM') + " - " + moment().endOf("isoWeek").format('DD MMM');

                this.currentPeriodStart = moment().startOf("isoWeek");
                this.currentPeriodEnd = moment().endOf("isoWeek");

                this.startOfWeek = moment().startOf("isoWeek");
                this.endOfWeek = moment().endOf("isoWeek");
            }
            else if (filterType === "last_week") {
                this.displayDate = moment().subtract(1, "weeks").startOf("isoWeek").format('DD MMM') + " - " + moment().subtract(1, "weeks").endOf("isoWeek").format('DD MMM');

                this.currentPeriodStart = moment().subtract(1, "weeks").startOf("isoWeek");
                this.currentPeriodEnd = moment().subtract(1, "weeks").endOf("isoWeek");

                this.startOfWeek = moment().subtract(1, "weeks").startOf("isoWeek");
                this.endOfWeek = moment().subtract(1, "weeks").endOf("isoWeek");
            }
            else if (filterType === "this_month") {
                this.displayDate = moment().startOf("month").format('DD MMM') + " - " + moment().endOf("month").format('DD MMM');

                this.currentPeriodStart = moment().startOf('month')
                this.currentPeriodEnd = moment().endOf('month')

                this.currentMonth = moment();
            }
            else if (filterType === "last_month") {
                this.displayDate = moment().subtract(1, "month").startOf("month").format('DD MMM') + " - " + moment().subtract(1, "month").endOf("month").format('DD MMM');

                this.currentPeriodStart = moment().subtract(1, "month").startOf('month')
                this.currentPeriodEnd = moment().subtract(1, "month").endOf('month')

                this.currentMonth = moment().subtract(1, "month");
            }
            else if(filterType === "last_three_month") {
                this.displayDate = moment().subtract(3, "month").startOf("month").format('DD MMM') + " - " + moment().subtract(1, "month").endOf("month").format('DD MMM');

                this.currentPeriodStart = moment().subtract(3, "month").startOf('month')
                this.currentPeriodEnd = moment().subtract(1, "month").endOf('month')
            }
            else if (filterType === "this_year") {
                this.displayDate = moment().startOf("year").format('DD MMM YYYY') + " - " + moment().endOf("year").format('DD MMM YYYY');

                this.currentPeriodStart = moment().startOf('year')
                this.currentPeriodEnd = moment().endOf('year')
            }
            else if (filterType === "last_year") {
                this.displayDate = moment().subtract(1, "year").startOf("year").format('DD MMM YYYY') + " - " + moment().subtract(1, "year").endOf("year").format('DD MMM YYYY');

                this.currentPeriodStart = moment().subtract(1, "year").startOf('year')
                this.currentPeriodEnd = moment().subtract(1, "year").endOf('year')
            }
            this.generateCalendar();
        },
        getNextData() {
            if (this.dayOptions.includes(this.filters.optionValue)) {
                this.filters.optionValue = 'custom_day';

                this.currentPeriodStart = moment(this.currentPeriodStart).add(1, "days");
                this.currentPeriodEnd = moment(this.currentPeriodEnd).add(1, "days");
            }
            else if (this.weekOptions.includes(this.filters.optionValue)) {
                this.filters.optionValue = 'custom_week';

                this.currentPeriodStart = moment(this.currentPeriodStart).add(1, "weeks");
                this.currentPeriodEnd = moment(this.currentPeriodEnd).add(1, "weeks");

                this.startOfWeek = moment(this.startOfWeek).add(1, "weeks");
                this.endOfWeek = moment(this.endOfWeek).add(1, "weeks");
            }
            else if (this.monthOptions.includes(this.filters.optionValue)) {
                this.filters.optionValue = 'custom_month';

                this.currentPeriodStart = moment(this.currentPeriodStart).add(1, "months");
                this.currentPeriodEnd = moment(this.currentPeriodEnd).add(1, "months");

                this.currentMonth = moment(this.currentMonth).add(1, "months");
            }

            this.generateCalendar();
        },
        getPreviousData() {
            if (this.dayOptions.includes(this.filters.optionValue)) {
                this.filters.optionValue = 'custom_day';

                this.currentPeriodStart = moment(this.currentPeriodStart).subtract(1, "days");
                this.currentPeriodEnd = moment(this.currentPeriodEnd).subtract(1, "days");
            }
            else if (this.weekOptions.includes(this.filters.optionValue)) {
                this.filters.optionValue = 'custom_week';

                this.currentPeriodStart = moment(this.currentPeriodStart).subtract(1, "weeks");
                this.currentPeriodEnd = moment(this.currentPeriodEnd).subtract(1, "weeks");

                this.startOfWeek = moment(this.startOfWeek).subtract(1,"weeks");
                this.endOfWeek = moment(this.endOfWeek).subtract(1, "weeks");
            }
            else if (this.monthOptions.includes(this.filters.optionValue)) {
                this.filters.optionValue = 'custom_month';

                this.currentPeriodStart = moment(this.currentPeriodStart).subtract(1, "months");
                this.currentPeriodEnd = moment(this.currentPeriodEnd).subtract(1, "months");

                this.currentMonth = moment(this.currentMonth).subtract(1, "months");
            }
            this.generateCalendar();
        },
        initializePopovers() {
            nextTick(() => {
                // Destroy existing popovers
                const popovers = document.querySelectorAll('[data-bs-toggle="popover"]');
                popovers.forEach((popover) => {
                    const instance = bootstrap.Popover.getInstance(popover);
                    if (instance) {
                        instance.dispose();
                    }
                });

                // Initialize new popovers
                popovers.forEach((popover) => {
                    new bootstrap.Popover(popover);
                });
            });
        },
        preparePopoverContent(element) {
            return `
                ${element?.histories?.map((history, index) => {
                    const historyData = history?.data || null;
                    const hasBorder = index !== element?.histories?.length - 1;
                    return `
                        <div class="work-history-container hm-fs-11 ${hasBorder ? 'border-bottom mb-2' : ''}">
                            <div class="fw-bold d-block text-capitalize hm-fs-12">${history?.user?.name || ''}</div>
                            ${
                                historyData?.logs?.length > 0
                                ? historyData?.logs?.map((log, index) => {
                                        return `
                                            <div class="d-block">
                                                ${log?.value}
                                            </div>
                                        `;
                                    }).join('')
                                : ''
                            }
                            ${!historyData?.logs?.length && history?.comment ? `
                                <div class="d-block">${history?.comment}</div>
                            ` : ''}
                            ${historyData?.deleted_items?.length ? `
                                <div class="col-md-12">
                                    <div class="fw-bold d-block text-capitalize mt-1 text-danger">Service Deleted</div>
                                    ${historyData?.deleted_items?.map(item => `
                                        <p class="mb-1">Service <span class="fw-bold">${item.service_name}</span> is deleted from the order.</p>
                                    `).join('')}
                                </div>
                            ` : ''}
                            ${historyData?.new_items?.length ? `
                                <div class="col-md-12">
                                    <div class="fw-bold d-block text-capitalize mt-1 text-success">Service Added</div>
                                    ${historyData?.new_items?.map(item => `
                                        <p class="mb-1">Service <span class="fw-bold">${item.service_name}</span> is added to the order.</p>
                                    `).join('')}
                                </div>
                            ` : ''}
                            ${historyData?.updated_items?.length ? `
                                <div class="col-md-12">
                                    <div class="fw-bold d-block text-capitalize mt-1 text-warning">Service Updated</div>
                                    ${historyData?.updated_items?.map(item => `
                                        <p class="mb-1">Service <span class="fw-bold">${item.service_name}</span> is updated in the order.</p>
                                    `).join('')}
                                </div>
                            ` : ''}
                        </div>
                    `;
                }).join('')}
            `;
        }
    },
    watch: {
        filters: {
            handler() {
                this.initializePopovers();
                //this.generateCalendar();
            },
            deep: true
        },
       'filters.optionValue': {
            handler() {
                this.prepareDisplayDate();
            },
            deep: true
        }
    },
};
</script>
<style scoped>
.flip-list-move {
    transition: transform 0.5s;
}

.no-move {
    transition: transform 0s;
}

.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}
.order-list-group-item {
    /* cursor: move; */
}
.order-list-group {
    min-height: 100px;
}


.calendar {
    display: flex;
    flex-direction: column;
}
.week-days, .week {
    display: flex;
}
.day-header, .date {
    flex: 1 0 14%; /* approximately 14% to fit 7 items in a row */
    text-align: center;
    border: 1px solid #ccc;
    padding: 8px;
}
.empty-date {
    background-color: #f0f0f0; /* Light gray background for empty dates */
}

</style>
